import React, { useState } from 'react'
import Table from './common/Table'
import { useLoad } from '../hooks/request'
import { BILLING_DEBT_LIST } from '../urls'

function money(value) {
    return new Intl.NumberFormat('ru-RU').format(value || 0)
}

/**
 * Korxonalar kesimida umumiy qarz — barcha oylar bo'yicha yig'indi.
 *
 * Oylik ro'yxatdan farqi: bu yerda "kim jami qancha qarz" ko'rinadi,
 * qaysi oyda ekani emas.
 */
export default function ContractCompanyDebt() {
    const [module, setModule] = useState('')
    const [search, setSearch] = useState('')
    const [onlyDebt, setOnlyDebt] = useState(true)

    const params = {
        ...(module ? { module } : {}),
        ...(search ? { search } : {}),
        ...(onlyDebt ? { only_debt: true } : {}),
    }

    const debts = useLoad({ url: BILLING_DEBT_LIST, params }, [module, search, onlyDebt])
    const response = debts.response || {}
    const totals = response.totals || {}

    return (
        <div>
            <div className="columns">
                <div className="column">
                    <div className="box">
                        <p className="heading">Начислено за всё время</p>
                        <p className="title is-5">{money(totals.expectedTotal)}</p>
                    </div>
                </div>
                <div className="column">
                    <div className="box">
                        <p className="heading">Оплачено</p>
                        <p className="title is-5 has-text-success">{money(totals.paidTotal)}</p>
                    </div>
                </div>
                <div className="column">
                    <div className="box">
                        <p className="heading">Общий долг</p>
                        <p className="title is-5 has-text-danger">{money(totals.debtTotal)}</p>
                    </div>
                </div>
                <div className="column">
                    <div className="box">
                        <p className="heading">Должников</p>
                        <p className="title is-5">
                            {totals.debtorCount || 0} / {totals.companyCount || 0}
                        </p>
                    </div>
                </div>
            </div>

            <div className="columns">
                <div className="column is-3">
                    <div className="select is-fullwidth">
                        <select value={module} onChange={(e) => setModule(e.target.value)}>
                            <option value="">Все модули</option>
                            <option value="zero">Nollik</option>
                            <option value="manthly">Oylik</option>
                        </select>
                    </div>
                </div>
                <div className="column is-3">
                    <label className="checkbox" htmlFor="only-debt">
                        <input
                            id="only-debt"
                            type="checkbox"
                            checked={onlyDebt}
                            onChange={(e) => setOnlyDebt(e.target.checked)} />
                        &nbsp; Только должники
                    </label>
                </div>
                <div className="column">
                    <input
                        className="input"
                        placeholder="Поиск по названию или СТИР..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)} />
                </div>
            </div>

            <Table
                loading={debts.loading}
                items={response.results || []}
                columns={{
                    company: 'Компания',
                    months: 'Месяцев',
                    expected: 'Начислено',
                    paid: 'Оплачено',
                    debt: 'Долг',
                    last: 'Последний платёж',
                }}
                renderItem={(item) => (
                    <tr key={`${item.module}-${item.companyId}`}>
                        <td>
                            {item.companyName}
                            <br />
                            <span className="has-text-grey is-size-7">
                                {item.moduleLabel}{item.stir ? ` · ${item.stir}` : ''}
                            </span>
                        </td>
                        <td>{item.months}</td>
                        <td>{money(item.expected)}</td>
                        <td className="has-text-success">{money(item.paid)}</td>
                        <td className={item.debt > 0 ? 'has-text-danger has-text-weight-bold' : 'has-text-grey'}>
                            {money(item.debt)}
                        </td>
                        <td className="has-text-grey is-size-7">
                            {item.lastPaymentDate || '—'}
                        </td>
                    </tr>
                )} />
        </div>
    )
}
